/* ============================================
   VADERFINDDS - ANIMATIONS JS
   ============================================ */

(function() {
  'use strict';

  /* ---- COUNT UP ANIMATION ---- */
  const counters = document.querySelectorAll('[data-count-up]');
  const countObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const target = parseInt(el.dataset.countUp);
        const duration = parseInt(el.dataset.duration || 1500);
        const start = 0;
        const startTime = performance.now();

        function update(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const current = Math.floor(start + (target - start) * eased);
          el.textContent = current.toLocaleString();
          if (progress < 1) requestAnimationFrame(update);
          else el.textContent = target.toLocaleString() + (el.dataset.suffix || '');
        }
        requestAnimationFrame(update);
        countObserver.unobserve(el);
      }
    });
  }, { threshold: 0.5 });
  counters.forEach(c => countObserver.observe(c));

  /* ---- PARALLAX SCROLL ---- */
  const parallaxEls = document.querySelectorAll('[data-parallax]');
  if (parallaxEls.length && window.matchMedia('(pointer: fine)').matches) {
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      parallaxEls.forEach(el => {
        const speed = parseFloat(el.dataset.parallax) || 0.3;
        const yPos = -(scrolled * speed);
        el.style.transform = `translateY(${yPos}px)`;
      });
    }, { passive: true });
  }

  /* ---- STAGGER REVEAL ON CHILDREN ---- */
  document.querySelectorAll('[data-stagger]').forEach(parent => {
    const children = parent.children;
    Array.from(children).forEach((child, i) => {
      child.classList.add('reveal');
      child.style.transitionDelay = (i * 0.08) + 's';
    });
  });

  /* ---- LAZY LOAD IMAGES ---- */
  if ('loading' in HTMLImageElement.prototype) {
    // Browser handles natively
  } else {
    const lazyImgs = document.querySelectorAll('img[loading="lazy"]');
    const imgObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imgObserver.unobserve(img);
        }
      });
    });
    lazyImgs.forEach(img => imgObserver.observe(img));
  }

  /* ---- SABER HOVER PULSE ---- */
  document.querySelectorAll('[data-saber-hover]').forEach(el => {
    el.addEventListener('mouseenter', () => {
      el.style.setProperty('--saber-glow-intensity', '1');
    });
    el.addEventListener('mouseleave', () => {
      el.style.setProperty('--saber-glow-intensity', '0.5');
    });
  });

  /* ---- IMAGE ZOOM ON HOVER ---- */
  document.querySelectorAll('[data-zoom]').forEach(wrap => {
    const img = wrap.querySelector('img');
    if (!img) return;
    wrap.addEventListener('mousemove', (e) => {
      const rect = wrap.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(1.4)';
    });
    wrap.addEventListener('mouseleave', () => {
      img.style.transform = '';
    });
  });

})();
